var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSortIconDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 9.91602H16.125C16.4702 9.91602 16.75 9.63619 16.75 9.29102C16.75 8.94584 16.4702 8.66602 16.125 8.66602H9.875C9.52982 8.66602 9.25 8.94584 9.25 9.29102C9.25 9.63619 9.52982 9.91602 9.875 9.91602Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 6.79102H18.625C18.9702 6.79102 19.25 6.51119 19.25 6.16602C19.25 5.82084 18.9702 5.54102 18.625 5.54102H9.875C9.52982 5.54102 9.25 5.82084 9.25 6.16602C9.25 6.51119 9.52982 6.79102 9.875 6.79102Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 16.166H11.125C11.4702 16.166 11.75 15.8862 11.75 15.541C11.75 15.1958 11.4702 14.916 11.125 14.916H9.875C9.52982 14.916 9.25 15.1958 9.25 15.541C9.25 15.8862 9.52982 16.166 9.875 16.166Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 13.041H13.625C13.9702 13.041 14.25 12.7612 14.25 12.416C14.25 12.0708 13.9702 11.791 13.625 11.791H9.875C9.52982 11.791 9.25 12.0708 9.25 12.416C9.25 12.7612 9.52982 13.041 9.875 13.041Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60374 13.4099C2.50997 13.3194 2.38261 13.2683 2.25 13.2683C2.11739 13.2683 1.99021 13.3192 1.89645 13.4097L1.89218 13.4139C1.8012 13.5041 1.75 13.6253 1.75 13.7512L1.75001 13.7539C1.75074 13.8811 1.80336 14.0028 1.89645 14.0927L3.89645 16.0246C3.99022 16.1151 4.11739 16.166 4.25 16.166C4.38261 16.166 4.50979 16.1151 4.60355 16.0246L6.60355 14.0927C6.69732 14.0022 6.75 13.8793 6.75 13.7512C6.75 13.7429 6.74978 13.7346 6.74933 13.7263C6.74293 13.607 6.691 13.4942 6.60355 13.4097C6.50979 13.3192 6.38261 13.2683 6.25 13.2683C6.11739 13.2683 5.99022 13.3192 5.89645 13.4097L4.25 15.0001L2.60374 13.4099Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.02397V15.6831C3.75 15.9498 3.97386 16.166 4.25 16.166C4.52614 16.166 4.75 15.9498 4.75 15.6831V6.02397C4.75 5.75724 4.52614 5.54102 4.25 5.54102C3.97386 5.54102 3.75 5.75724 3.75 6.02397Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIconDesc);
export default __webpack_public_path__ + "static/media/sortIconDesc.2fc7b6318448e1b66eb6a2d25c0476b6.svg";
export { ForwardRef as ReactComponent };